import React from "react"
import { processMarkdown } from "@/controllers/markdown";

interface MarkdownProps {
    content: string;
    allowHTML?: boolean | undefined;
}

const Markdown: React.FC<MarkdownProps> = ({ content, allowHTML = false }) => {
    if (!content) return;

    return <span
        className="markdown"
        dangerouslySetInnerHTML={{
            __html: processMarkdown(content, allowHTML ?? false),
        }}
    ></span>
}

export default Markdown;